import { STATIC_SERVICES, STATIC_BLOGS } from "./staticServices.js";

export const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:4001/api";

const STATIC_UPDATES = [
  { tag: "alert", text: "Important: Advance tax 4th instalment deadline is 15th March. Plan and file early to avoid interest." },
  { tag: "new", text: "New: Simplified Udyam Registration & MSME Advisory now live on Biz360 Compliance." },
  { tag: "live", text: "MCA V3 portal updates: SPICe+ and LLP annual filing assistance available PAN India." },
];

export const STATIC_TESTIMONIALS = [
  {
    name: "Vinay Waykar",
    role: "Founder, Shivpattan Bio Energy Private Limited",
    quote: "Good experience with Biz360Compliance for Private Limited Company incorporation, MCA filings, taxation and ongoing compliance. The team was professional, responsive and guided us well throughout the process.",
    content: "Good experience with Biz360Compliance for Private Limited Company incorporation, MCA filings, taxation and ongoing compliance. The team was professional, responsive and guided us well throughout the process.",
    rating: 5,
    image: "/vinay-waykar.png",
  },
  {
    name: "Pooja Kathole",
    role: "Director, Genexpro Ventures Pvt Ltd",
    quote: "We, Genexpro Ventures Pvt Ltd, have had a good experience with Biz360Compliance for GST compliance, Income Tax, accounting and audit support. Their team understands our agri-products Business, wholesale trading and export transactions, and provides practical guidance with timely compliance.",
    content: "We, Genexpro Ventures Pvt Ltd, have had a good experience with Biz360Compliance for GST compliance, Income Tax, accounting and audit support. Their team understands our agri-products Business, wholesale trading and export transactions, and provides practical guidance with timely compliance.",
    rating: 5,
    image: "/pooja-kathole.jpg",
  },
  {
    name: "Uday Chaudhari",
    role: "Designated Partner, Shreeji Greliance Bioenergy LLP",
    quote: "Good experience with Biz360Compliance for LLP incorporation and post-incorporation services. They assisted us with MCA filings, accounting setup, compliance and audit support. The team was professional, responsive and provided practical guidance throughout the process.",
    content: "Good experience with Biz360Compliance for LLP incorporation and post-incorporation services. They assisted us with MCA filings, accounting setup, compliance and audit support. The team was professional, responsive and provided practical guidance throughout the process.",
    rating: 5,
    image: "",
  },
  {
    name: "Sagar Autade",
    role: "CTO, PragyaSuite Technologies LLP",
    quote: "Biz360Compliance made our LLP incorporation seamless and straightforward. From name approval and LLP agreement drafting to MCA filings and post-incorporation setup, the team was professional, responsive, and always proactive.",
    content: "Biz360Compliance made our LLP incorporation seamless and straightforward. From name approval and LLP agreement drafting to MCA filings and post-incorporation setup, the team was professional, responsive, and always proactive.",
    rating: 5,
    image: "/sagar-autade.png",
  },
];

const STATIC_PRICING = [
  {
    icon: "Building2",
    title: "Private Limited Company",
    badge: "Most Popular",
    rating: 4.9,
    price: "₹6,999",
    price_note: "+ Govt. fees",
    features: [
      "2 Digital Signature Certificates (DSC)",
      "2 Director Identification Numbers (DIN)",
      "Name Approval Assistance (RUN)",
      "SPICe+ MOA & AOA Drafting",
      "Certificate of Incorporation (CIN)",
      "Company PAN & TAN Allotment",
      "Bank Account Opening Support",
    ],
    slug: "private-limited-company",
  },
  {
    icon: "Landmark",
    title: "LLP Registration",
    badge: "",
    rating: 4.8,
    price: "₹4,999",
    price_note: "+ Govt. fees",
    features: [
      "2 Designated Partner DSCs",
      "2 Designated Partner DPINs",
      "Name Approval via RUN-LLP",
      "LLP Agreement Drafting & Filing",
      "Certificate of Incorporation",
      "LLP PAN & TAN Allotment",
    ],
    slug: "llp",
  },
  {
    icon: "Receipt",
    title: "GST Registration",
    badge: "Essential",
    rating: 4.9,
    price: "₹1,499",
    price_note: "all inclusive",
    features: [
      "Application Preparation & Filing",
      "Document Verification",
      "ARN Generation & Tracking",
      "Department Query Clarification",
      "GSTIN Certificate Delivery",
      "Initial 1 Month Return Guidance",
    ],
    slug: "gst-registration",
  },
  {
    icon: "ShieldCheck",
    title: "Annual ROC Compliance",
    badge: "",
    rating: 4.8,
    price: "₹9,999",
    price_note: "annual",
    features: [
      "AOC-4 Financial Statement Filing",
      "MGT-7/7A Annual Return Filing",
      "Director KYC (DIR-3 KYC)",
      "Statutory Registers Maintenance",
      "Minutes & Resolutions Drafting",
      "Compliance Due Date Reminders",
    ],
    slug: "roc-mca-annual-compliance",
  },
];

const request = async (path, { method = "GET", body, token, isForm = false } = {}) => {
  const headers = {};
  if (token) headers.Authorization = `Bearer ${token}`;
  if (!isForm && body) headers["Content-Type"] = "application/json";

  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers,
    body: isForm ? body : body ? JSON.stringify(body) : undefined,
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || "Something went wrong. Please try again.");
  return data;
};

export const api = {
  signup: (payload) => request("/auth/signup", { method: "POST", body: payload }),
  login: (payload) => request("/auth/login", { method: "POST", body: payload }),
  me: (token) => request("/auth/me", { token }),
  uploadDocuments: (token, formData) => request("/documents", { method: "POST", token, body: formData, isForm: true }),
  uploadDocumentsFor: (token, clientId, formData) => request(`/documents/for/${clientId}`, { method: "POST", token, body: formData, isForm: true }),
  myDocuments: (token) => request("/documents/mine", { token }),
  replaceDocument: (token, id, formData) => request(`/documents/${id}/replace`, { method: "PUT", token, body: formData, isForm: true }),
  allDocuments: (token) => request("/documents", { token }),
  updateDocumentStatus: (token, id, status) => request(`/documents/${id}/status`, { method: "PATCH", token, body: { status } }),
  adminStats: (token) => request("/admin/stats", { token }),
  adminUsers: (token) => request("/admin/users", { token }),
  adminUserDocuments: (token, userId) => request(`/admin/users/${userId}/documents`, { token }),
  setApplicationStatus: (token, clientId, slug, status, note) =>
    request(`/admin/users/${clientId}/applications/${slug}/status`, { method: "PUT", token, body: { status, note } }),
  myApplications: (token) => request("/documents/mine/applications", { token }),
  setRemarks: (token, userId, remarks) => request(`/admin/users/${userId}/remarks`, { method: "PUT", token, body: { remarks } }),
  adminList: (token) => request("/admin/admins", { token }),
  adminCreate: (token, payload) => request("/admin/admins", { method: "POST", token, body: payload }),
  clientCreate: (token, payload) => request("/admin/clients", { method: "POST", token, body: payload }),
  adminDelete: (token, id) => request(`/admin/admins/${id}`, { method: "DELETE", token }),
  subadminDelete: (token, id) => request(`/admin/subadmins/${id}`, { method: "DELETE", token }),
  subadminList: (token) => request("/admin/subadmins", { token }),
  subadminCreate: (token, payload) => request("/admin/subadmins", { method: "POST", token, body: payload }),
  subadminClients: (token, subadminId) => request(`/admin/subadmins/${subadminId}/clients`, { token }),
  assignClientToSubadmin: (token, subadminId, clientId) =>
    request(`/admin/subadmins/${subadminId}/clients`, { method: "POST", token, body: { clientId } }),
  unassignClientFromSubadmin: (token, subadminId, clientId) =>
    request(`/admin/subadmins/${subadminId}/clients/${clientId}`, { method: "DELETE", token }),
  listBlogs: async () => {
    try {
      const res = await request("/content/blogs");
      if (res?.posts && res.posts.length > 0) return res;
    } catch (_) {}
    return { posts: STATIC_BLOGS };
  },
  sendEnquiry: async (formData) => {
    try {
      return await request("/enquiries", { method: "POST", body: formData, isForm: true });
    } catch (_) {
      return { ok: true, message: "Thank you for reaching out! We have received your details and will get in touch shortly." };
    }
  },
  listEnquiries: (token) => request("/enquiries", { token }),
  getBlog: async (slug) => {
    try {
      const res = await request(`/content/blogs/${slug}`);
      if (res?.post) return res;
    } catch (_) {}
    const post = STATIC_BLOGS.find((b) => b.slug === slug);
    if (post) return { post };
    throw new Error("Blog post not found");
  },
  createBlog: (token, payload) => request("/content/blogs", { method: "POST", token, body: payload }),
  updateBlog: (token, id, payload) => request(`/content/blogs/${id}`, { method: "PUT", token, body: payload }),
  deleteBlog: (token, id) => request(`/content/blogs/${id}`, { method: "DELETE", token }),
  listServices: async (category) => {
    try {
      const res = await request(`/content/services${category ? `?category=${encodeURIComponent(category)}` : ""}`);
      if (res?.services && res.services.length > 0) return res;
    } catch (_) {}
    const filtered = category
      ? STATIC_SERVICES.filter((s) => s.category.toLowerCase() === category.toLowerCase())
      : STATIC_SERVICES;
    return { services: filtered };
  },
  getService: async (slug) => {
    try {
      const res = await request(`/content/services/${slug}`);
      if (res?.service) return res;
    } catch (_) {}
    const service = STATIC_SERVICES.find((s) => s.slug === slug);
    if (service) return { service };
    throw new Error("Service not found");
  },
  createService: (token, payload) => request("/content/services", { method: "POST", token, body: payload }),
  updateService: (token, id, payload) => request(`/content/services/${id}`, { method: "PUT", token, body: payload }),
  deleteService: (token, id) => request(`/content/services/${id}`, { method: "DELETE", token }),
  listUpdates: async () => {
    try {
      const res = await request("/content/updates");
      if (res?.updates && res.updates.length > 0) return res;
    } catch (_) {}
    return { updates: STATIC_UPDATES };
  },
  createUpdate: (token, payload) => request("/content/updates", { method: "POST", token, body: payload }),
  updateUpdate: (token, id, payload) => request(`/content/updates/${id}`, { method: "PUT", token, body: payload }),
  deleteUpdate: (token, id) => request(`/content/updates/${id}`, { method: "DELETE", token }),
  listTestimonials: async ({ raw = false } = {}) => {
    try {
      const res = await request("/content/testimonials");
      if (raw) return res?.testimonials ? res : { testimonials: [] };
      if (res?.testimonials && res.testimonials.length > 0) {
        // Filter out legacy dummy placeholder seed testimonials (Ananya, Rahul, Priya)
        const DUMMY_NAMES = new Set(["Ananya Sharma", "Rahul Menon", "Priya Nair"]);
        const real = res.testimonials.filter((t) => !DUMMY_NAMES.has(t.name));
        if (real.length > 0) return { testimonials: real };
      }
    } catch (_) {}
    return { testimonials: STATIC_TESTIMONIALS };
  },
  createTestimonial: (token, payload) => request("/content/testimonials", { method: "POST", token, body: payload }),
  updateTestimonial: (token, id, payload) => request(`/content/testimonials/${id}`, { method: "PUT", token, body: payload }),
  deleteTestimonial: (token, id) => request(`/content/testimonials/${id}`, { method: "DELETE", token }),
  listPricing: async () => {
    try {
      const res = await request("/content/pricing");
      if (res?.plans && res.plans.length > 0) return res;
    } catch (_) {}
    return { plans: STATIC_PRICING };
  },
  createPricing: (token, payload) => request("/content/pricing", { method: "POST", token, body: payload }),
  updatePricing: (token, id, payload) => request(`/content/pricing/${id}`, { method: "PUT", token, body: payload }),
  deletePricing: (token, id) => request(`/content/pricing/${id}`, { method: "DELETE", token }),
  uploadContentImage: (token, file) => {
    const formData = new FormData();
    formData.append("image", file);
    return request("/content/images", { method: "POST", token, body: formData, isForm: true });
  },
  downloadDocument: async (token, id, fileName) => {
    const res = await fetch(`${API_BASE}/documents/${id}/download`, { headers: { Authorization: `Bearer ${token}` } });
    if (!res.ok) throw new Error("Could not download this document.");
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName || "document";
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  },
};
